import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "X-Session-ID": sessionId },
          credentials: "include",
        });
        if (!res.ok) throw new Error("auth failed");
        const user = await res.json();
        window.history.replaceState({}, document.title, "/inbox");
        navigate("/inbox", { replace: true, state: { user } });
      } catch (e) {
        navigate("/login", { replace: true, state: { error: "not_authorised" } });
      }
    };
    run();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-brand-primary/20 border-t-brand-primary animate-spin" />
        <p className="mt-6 font-display text-xl text-brand-primary">Signing you in…</p>
      </div>
    </div>
  );
}
